import { homeContentDefaults } from "./content/home.content";
import { bookingContentDefaults } from "./content/booking.content";
import { bookingFormContentDefaults } from "./content/bookingForm.content";
import { decorationsContentDefaults } from "./content/decorations.content";

export const CMS_VERSION = 1;

/**
 * Full site CMS snapshot. Persisted in localStorage + editable in Admin.
 * theaterMedia keys: normalized theatre folder name (see normalizeTheaterFolderKey), e.g. "FAMILY", "MERCURY"
 */
export function buildDefaultSiteCms() {
  return {
    version: CMS_VERSION,
    home: { ...homeContentDefaults },
    booking: { ...bookingContentDefaults },
    bookingForm: { ...bookingFormContentDefaults },
    decorations: { ...decorationsContentDefaults },
    theaterMedia: {},
  };
}

export const defaultSiteCms = buildDefaultSiteCms();
